import { Link } from 'react-router-dom';
import { useMe } from '../api/hooks';
import { de } from '../i18n/de';
import { Avatar } from './Avatar';

/** Knopf zum Profil: Foto (bzw. Initiale) und „Profil“. Aus einer Geschichte heraus kennt das Profil sie (Typen, Zurück). */
export function ProfileLink({ projectId }: { projectId?: string }) {
  const { data: me } = useMe();
  return (
    <Link className="btn profile-link" to={projectId ? `/profile?project=${encodeURIComponent(projectId)}` : '/profile'} title={de.profile.title} aria-label={de.profile.title} data-testid="open-profile">
      <Avatar user={me?.user} size={26} />
      <span className="btn-text">{de.profile.title}</span>
    </Link>
  );
}
